import React from 'react';

// Show initial loading screen while prefetching all categories
const LoadingState: React.FC = () => {
  return (
    <div className="space-y-6">
      {/* Loading State */}
      <div className="bg-white rounded-xl shadow-md border border-gray-200 p-12">
        <div className="text-center">
          <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <div className="animate-spin h-8 w-8 border-3 border-blue-500 border-t-transparent rounded-full"></div>
          </div>
          <h2 className="text-2xl font-baijamjuree font-extrabold text-black mb-4">
            Final Round Evaluation
          </h2>
          <p className="text-lg text-gray-700 font-baijamjuree mb-2">
            Loading evaluation criteria...
          </p>
          <p className="text-sm text-gray-500 font-baijamjuree">
            Preparing scoring guidelines for all categories
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoadingState;
